module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_showroom-462520f39cc5859fbcc2d2c236812b89.jpg";